import React,{useEffect} from "react";
import "../styles/About.css";
import mission from "../assets/mission.jpeg"

export default function Mission() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);
  return (
    <div className="mission-container">
      <div className="Mission-div">
        <h2 className="mission-heading">Mission</h2>
          <img src={mission} alt="open book" />
        <p>
          Our mission is to deliver exceptional drone services that enhance
          business operations and community engagement. We are committed to:
          Empowering aspiring remote pilots through mentorship and job
          opportunities. Promoting awareness and education about drone
          technology in underserved communities. Upholding the highest standards
          of safety and professionalism in all our operations. Aim Our aim is to
          establish GiftEng Aerial Solutions as a trusted partner in various
          sectors, including agriculture, real estate, and mining, by providing
          reliable drone services that meet our clients' unique needs. We strive
          to contribute positively to the local economy and society while
          nurturing the growth of the drone industry in South Africa.
        </p>
      </div>
    </div>
  );
}
